import type { ReactNode } from 'react'

interface DropdownMenuItemProps {
    icon?: ReactNode
    children: ReactNode
    onClick: () => void
    className?: string
}

export function DropdownMenuItem({
    icon,
    children,
    onClick,
    className = '',
}: DropdownMenuItemProps) {
    return (
        <button
            onClick={onClick}
            className={`w-full px-4 py-2 text-left text-sm text-text-primary-light dark:text-text-primary-dark hover:bg-border-light/30 dark:hover:bg-white/10 flex items-center gap-2 transition-colors ${className}`}
        >
            {icon}
            {children}
        </button>
    )
}
